/* Minéral - images différées (oct. 2026, vitesse).
   Une image dont les adresses sont en data-mpn-srcset / data-mpn-src n'est pas téléchargée tant qu'on ne l'active pas.
   - [data-mpn-defer-scope] : zone (slider de carte produit, carrousel de produits) dont les images différées
     s'activent au 1er contact : doigt posé, clic, souris au-dessus, focus clavier, défilement.
     data-mpn-keep="mobile,tablette,ordinateur" : nombre d'éléments [data-mpn-i] visibles d'emblée (activés tout de suite).
   - img[data-mpn-hover] : photo de survol des cartes produit, visible seulement à 990 px et plus (survol souris) :
     activée tout de suite à partir de 990 px, jamais téléchargée en dessous (sauf survol réel de la carte).
   - img[data-mpn-lazy] : l'image utilisait le chargement différé du thème (lazy-src / lazy-srcset, snippets/observer-CFH) :
     on lui rend ces attributs tant que ce chargement n'a pas encore été déclenché, sinon src / srcset directement. */
(function () {
  if (window.__mpnLazyMedia) return; window.__mpnLazyMedia = true;
  var mqDesk = window.matchMedia('(min-width: 990px)');
  var mqTab = window.matchMedia('(min-width: 750px)');
  var SEL = 'img[data-mpn-srcset],img[data-mpn-src]';

  function wake(im) {
    var ss = im.getAttribute('data-mpn-srcset'), s = im.getAttribute('data-mpn-src');
    if (ss === null && s === null) return;
    var lazy = im.hasAttribute('data-mpn-lazy') && !(document.body && document.body.getAttribute('lazyLoaded'));
    if (ss !== null) { im.setAttribute(lazy ? 'lazy-srcset' : 'srcset', ss); im.removeAttribute('data-mpn-srcset'); }
    if (s !== null) { im.setAttribute(lazy ? 'lazy-src' : 'src', s); im.removeAttribute('data-mpn-src'); }
    im.removeAttribute('data-mpn-lazy');
  }

  function keep(sc) {
    var k = (sc.getAttribute('data-mpn-keep') || '').split(',');
    var v = parseInt(mqDesk.matches ? k[2] : (mqTab.matches ? k[1] : k[0]), 10);
    return v > 0 ? v : 0;
  }

  function allowed(im) {
    var sc = im.closest('[data-mpn-defer-scope]');
    if (sc && !sc.hasAttribute('data-mpn-woken')) {
      var n = keep(sc), it = im.closest('[data-mpn-i]');
      if (!n || !it || (parseInt(it.getAttribute('data-mpn-i'), 10) || 0) > n) return false;
    }
    if (im.hasAttribute('data-mpn-hover') && !mqDesk.matches) {
      var c = im.closest('.card-wrapper');
      if (!c || !c.hasAttribute('data-mpn-hover-woken')) return false;
    }
    return true;
  }

  function pass() {
    var list = document.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) if (allowed(list[i])) wake(list[i]);
  }

  function onEvent(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var changed = false;
    var sc = t.closest('[data-mpn-defer-scope]');
    if (sc && !sc.hasAttribute('data-mpn-woken')) { sc.setAttribute('data-mpn-woken', ''); changed = true; }
    if (e.type === 'mouseover') {
      var c = t.closest('.card-wrapper');
      if (c && !c.hasAttribute('data-mpn-hover-woken') && c.querySelector('img[data-mpn-hover]')) { c.setAttribute('data-mpn-hover-woken', ''); changed = true; }
    }
    if (changed) pass();
  }

  ['touchstart', 'pointerdown', 'mouseover', 'focusin'].forEach(function (n) {
    document.addEventListener(n, onEvent, { passive: true, capture: true });
  });
  // Défilement horizontal d'un slider (doigt, pavé tactile, flèches) : l'événement scroll ne remonte pas, on l'écoute en capture
  document.addEventListener('scroll', function (e) { if (e.target && e.target.nodeType === 1) onEvent(e); }, { passive: true, capture: true });

  function onMq() { pass(); }
  if (mqDesk.addEventListener) { mqDesk.addEventListener('change', onMq); mqTab.addEventListener('change', onMq); }
  else if (mqDesk.addListener) { mqDesk.addListener(onMq); mqTab.addListener(onMq); }

  // Produits ajoutés après coup (défilement infini, onglets de carrousel décodés, filtres)
  var timer;
  function start() {
    pass();
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        if (m[i].addedNodes && m[i].addedNodes.length) { clearTimeout(timer); timer = setTimeout(pass, 50); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
